import React from 'react';

import GetInTouch from 'core/components/GetInTouch';

import SlideShow from './components/SlideShow';
import About from './components/About';

class Home extends React.Component {
    render() {
        return (
            <div>
                <SlideShow />
                <hr />
                <div className="md-flex">
                    <div className="md-col-8 pr3">
                        <About />
                    </div>
                    <div className="md-col-4">
                        <GetInTouch />
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js